import { apiPost } from './apiClient';

/**
 * Create a Checkout Session for the selected packs on the server.
 * Uses backend route POST /api/stripe/purchase-ateliers-pack
 * Body: { packIds: string[] }
 * Returns { sessionId, url }
 */
export async function createCheckoutSession({ packIds = [] } = {}) {
  try {
    const payload = { packIds };
    const resp = await apiPost('/api/stripe/purchase-ateliers-pack', payload);
    // Expected shape: { sessionId, url }
    return resp;
  } catch (error) {
    console.error('createCheckoutSession error', error);
    throw error;
  }
}

/**
 * Complete purchase by validating payment and adding packs to user.
 * Uses backend route POST /api/purchase-packs
 * Body: { packIds: string[], paymentIntentId: string }
 */
export async function completePurchase({ packIds = [], paymentIntentId }) {
  try {
    const payload = { packIds, paymentIntentId };
    const resp = await apiPost('/api/purchase-packs', payload);
    // Expected: success response (no specific return shape needed)
    return resp;
  } catch (error) {
    console.error('completePurchase error', error);
    throw error;
  }
}
